import { render, staticRenderFns } from "./IconStripePowered.vue?vue&type=template&id=151ec751&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ec751",
  null
  
)

export default component.exports